<script>
    import { createEventDispatcher } from 'svelte';

    import Toggle from './Toggle.svelte';
    import { isNullOrUndefined } from '../utils';

    const dispatch = createEventDispatcher();

    export let description;
    export let showDescription = false;

    function toggleshowDescription() {
        if (isNullOrUndefined(description) || description.length === 0) {
            return;
        }
        const newShowDescription = !showDescription;
        dispatch('updateShowDescription', {
            newShowDescription
        });
    }

    $: checked = (isNullOrUndefined(description)) ? false : showDescription;
</script>

<div>
    <span class={(isNullOrUndefined(description)) ? "dne" : ""}>Show Description</span>
    <Toggle toggled={checked} clickFunc={toggleshowDescription} />
</div>

<style>
    div {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
    }

    span {
        font-size: 22px;
        font-weight: 700;
        display: inline-block;
        padding-right: 10px;
    }

    .dne {
        color: var(--grey);
    }
</style>
